import { render, staticRenderFns } from "./TransferEmpty.vue?vue&type=template&id=2116f47d"
import script from "./TransferEmpty.vue?vue&type=script&lang=js"
export * from "./TransferEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports